import CONTACT_STATES from 'lib/common/constants/contactStates';
import CONTACT_TYPES from 'lib/common/constants/contactTypes';

import TTask from 'lib/common/types/Task';

export default function getConnectedCallContact(tasks: TTask[]) {
  return tasks.find(
    (task) =>
      (task.type === CONTACT_TYPES.CALL ||
        task.type === CONTACT_TYPES.CONFERENCE_CALL ||
        task.type === CONTACT_TYPES.QUEUE_CALLBACK) &&
      task.status === CONTACT_STATES.CONNECTED
  )?.contact;
}
